<template lang="pug">
#app
	include includes/header-top.pug
	transition(name="fade")
		router-view
</template>

<script>
	export default {
		mounted() {
			window.fbAsyncInit = function() {FB.init({ xfbml:true, version:'v3.2'});};
		}
	}
</script>
<style lang="scss">

	@import './src/assets/scss/style';
	
	html{
		font-size: 20px;
		@include media-breakpoint-down(md){
			font-size: 16px;
			// hyphens: auto;
		}
	}
	.container{
		max-width: 50rem;
	}
//
	// Details
	//	
	.teprotejo{
		height: 3rem;
		margin-top: 1rem;
	}

	//
	// Type
	//	
	.badge.badge-paihuen{
		background-color: rgba($paihuen,.1);
		color: rgba($paihuen,.9);
		border-radius: 3rem;
		font-size: .8rem;
		padding: .5rem 1rem;
		font-weight: bold !important;
		display: table;
		&.badge-center{
			margin: 0 auto 1rem !important;
		}
	}
	.font-normal{
		font-weight: normal !important;
	}
	.text-underline{
		text-decoration: underline;
	}
	.text-hint{
		color: gray;
	}

	.eyebrow{
		// font-weight: normal !important;
	}
	// texto dentro de imagen teprotejo
.certificacion{
	position: relative;
	top: 0;
	.url{
		top: 18px;
		left: 62px;
		position: absolute;
	}
	small{
		color: #86919c;
		font-size: 14px;
	}
}
ul{
	&.lead{
		li{
			font-size: 1rem;
			margin-bottom: 1rem;
			margin-top: 1rem;
			list-style: disc;
			letter-spacing: -0.1px;
			line-height: 1.5;
			padding-left: 0.25rem;
			margin-left: 1rem;
		}
	}
}

//
// Pages
//
.p-page{
	h1,h2,h3{
		font-weight: bold;
		line-height: 1.1;
	}
	.h1{
		letter-spacing: -1px;
	}
	h2,h3,h4,
	.h2,.h3,.h4{
		letter-spacing: -.5px;
	}
	h2{
		@include media-breakpoint-down(md){
			text-align: left;
		}
	}
	//
	.buy-cta{
		display: block;
		.payment-methods-item{
			img{
				width: auto;
				max-width: 320px;
				max-height: 25px;
				margin-bottom: .1rem;
			}
		}

		@include media-breakpoint-down(sm){
			.btn{
				margin-bottom: 1rem; 
				display: block;
			}
			.payment-methods-item{
				display: block;
				img, small{
					margin-bottom: 1rem;
					text-align: center;
				}
				img{
					max-width: 100%;
					margin: 0 auto .2rem; 
					max-height: inherit;
				}
			}
		}
	}

	section{
		&.welcome{
			display: flex;
			height: auto;
			height: calc(100vh - 6rem);
			.welcome-image, .welcome-content{
				flex: 1;
			}
			.welcome-image{
				width: 100%;
				background-color: #f2f2f2;
				position: relative;
				.image{
					position: absolute;
					top: 0; left: 0;
					width: 100%;height: 100%;
					background-position: center;
					background-size: cover;
				}
			}
			.welcome-content{
				padding: 0 1rem;
				display: flex;
				align-items: center!important;
			}

			.buy-cta{
				display: flex;
				justify-content: flex-start;
				.price, .btn-buy, .payment-methods-item{
					margin-right: 1rem;
				}
				.price{
					font-size: 1.5rem;
					margin-bottom: 1rem;
					display: flex;
				}
			}
		}

		@include media-breakpoint-up(md){
			&.welcome{
				.welcome-content{
				}
			}
		}

	}

	// Mobile
	@include media-breakpoint-down(md){
		section{
			&.welcome{
				min-height: 100vh;
				height: auto;
				display: flex;
				align-items: flex-end;
				padding: 0rem;
				flex-direction: column!important;
				.welcome-image{
					min-height: 70vh;
					position: relative;
					z-index: 0;
					margin-bottom: -5vh;
				}
				.welcome-content{
					padding: 1.5rem 0;
					position: relative;
					display: flex;
					width: 96vw;
					background-color: white;
					z-index: 9;
					margin: 0 auto;
					border-radius: $border-radius-md;
					align-items: flex-start!important;
					box-shadow: 5px 9px 25px 0px rgba(0, 0, 0, 0.15);
				}
				.eyebrow,
				.display-4,
				{
					margin-bottom: 1rem !important; 
				}
				.eyebrow{
					letter-spacing: 0 !important;
					margin-top: 0rem !important; 
					font-size: 1rem;
				}
				h1{
					font-size: 2rem;
				}
				// p{
				// 	display: none !important;
				// }
				.price{
					display: flex;
					font-size: 1.2rem !important;
					*{
						display: flex;
					}
				}
				.buy-cta{
					display: flex;
					.price, .btn-buy{
						margin-bottom: 0 !important;
						align-self: stretch;
						align-items: center!important;
					}
					.btn-buy{
						.btn{
							margin-bottom: 0 !important;
						}
					}
				}
				.payment-methods-item{
					text-align: center;
					display: none;
				}
			}
		}
	}
}

.home{
	section{
		&.welcome{
			padding: 2rem 0 1rem; 
			min-height: inherit;
			height: auto;
		}
		@include media-breakpoint-down(md){
			&.section-block{
				padding: 0;
				align-items: initial;
				text-align: center !important;
				p.lead{
					display:  block !important; 
					margin-bottom: 1rem !important;
				}
				.buy-cta{
					.btn-buy{
						margin: 0 auto !important;
					}
				}
			}
		}
		@include media-breakpoint-up(md){
			&.section-block{
				padding: 1rem;
				max-width: 60rem;
				.section-wrapper{
					position: relative;
					z-index: 9;
					padding:  0;
					overflow: hidden;
					align-items: center!important;
					display: flex;
					flex: 1;
					border-radius: $border-radius-md;
					background: white;
					box-shadow: $box-shadow-md;
				}
				.welcome-image,
				.welcome-content
				{
					flex: 1;
					box-shadow: none;
				}
				.welcome-image{
					overflow: hidden;
					height: 100%;
					min-height: 30rem;
					max-height: 100vh;
				}
				.welcome-content{
					background-color: white;
					padding: 2rem 1rem;
					bottom: 2rem;
					border-radius: $border-radius-md;
				}
			}
		}
		@include media-breakpoint-down(md){
			&.welcome{
					.display-4{
						font-size: 2.2rem !important;
						text-align: center;
					}
					.lead{
						margin-bottom: .5rem !important;
						text-align: center;
					}
			}
		}
	}
}

.paihuen{
	.intro{
		display: flex;
		align-items: center !important;
		position: relative;
		height: 100vh;
		.section-image, .section-content{
			flex: 1;
		}
		.section-image{
			width: 50vw;
			right:  15vw;
			background-color: #f2f2f2;
			position: absolute;
			height: 100%;
			top: 0;
			.image{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-position: center;
				background-size: cover;
				&:after{
					// background-color: $paihuen;
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					z-index: 1;
					content: '';
					
				}
			}
		}
		.section-content{
			padding: 0 1rem;
		}
	}
	#inicio{
		text-align: center;
		h1{
		}
		.canvas{
			position: absolute;
			width: 100%;
			height: 100%;
		}
		.action{
			position: relative;
			z-index: 2;
			margin-left: auto;
			margin-right: auto;
			display: inline-block;
		}
		.bg-img{
			position: absolute;
			&.plants-01{
				max-height: 25vh;
				z-index: 0;
				animation-name: leftplantywafe;
				animation-duration: 10s;
				animation-timing-function: ease-in-out;
				animation-iteration-count: infinite;
				transform-origin: 100px 100px;

				left: -35%;
				bottom: -5%;
			}
			&.plants-02{
				max-width: 40vw;
				z-index: 0;

				left: -20%;
				bottom: -10%;

				animation-name: leftplantywafe;
				animation-duration: 10s;
				animation-timing-function: ease-in-out;
				animation-iteration-count: infinite;
				transform-origin: 250.895px 448.271px;
			}
			&.plants-03{
				max-width: 50vw;
				max-height: 60vh;
				z-index: 3;
				right: -20%;
				bottom: 0%;

				animation-name: plantywafe;
				animation-duration: 5s;
				animation-timing-function: ease-in-out;
				animation-iteration-count: infinite;
				transform-origin: 100px 120px;
			}
			&.plants-04{
				max-width: 50vw;
				z-index: 0;

				left: -20%;
				top: -25%;
			}
		}
	}
	#creando{
		background-color: white;
		text-align: center;
	}
	#respetando{
		text-align: center;
	}
	#utilizando{
		text-align: center;
	}
	#ayudando{
		text-align: center;
	}
	#humanidad{
		text-align: center;
	}
	#juntos{
		text-align: center;
	}
	.container-btn{	
		@include media-breakpoint-up(md){
			&.mobile{
				display: none;
			}
		}
		&.mobile{
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
			padding: 1rem;
			z-index: 9;
		}

	}
	.section{
		&.active{
			.d-none{
				display: block !important; 
			}
		}
	}
	@include media-breakpoint-down(md){
		.section{
			.display-4{
				font-size: 1.5rem;
				margin-bottom: 1rem !important;
			}
			p{
				font-size: 1rem;
				margin-bottom: 1rem !important;
				line-height: 1.5;
			}
			.container-fluid{
				.image-content{
					height: 50vh;
					display: flex;
					justify-content: center!important;
					align-items: flex-end!important;
				}
				.text-content{
					height: 50vh;
					padding: 1rem 2rem;
				}
				[attr-animate]{
					// height: 80vh;
					svg{
						// height: 100% !important;
						// min-height: 12rem;
						// max-height: 10rem;
						max-width: 100%;
						margin-bottom: 1rem;
					}
					img{
						max-height: 4.5rem;
						margin-bottom: 1rem;
					}
				}
			}
			.section-content{
				padding: 0;
				.container-btn{
					display: none;
				}
			}
		}
	}
}
.about{
	@include media-breakpoint-down(md){
		section.welcome{
			text-align: center;
			p {
				display: block !important;
			}
		}
	}
}
// 
.p-page{
	&.page{
		padding-top: 5rem;
	}
}

//
// Sections
//
.atributes{
	display: flex;
	justify-content: center!important;
	align-items: center!important;
	@include media-breakpoint-down(md){
		padding: 1rem 0 0;
	}
	@include media-breakpoint-up(md){
		height: 10vh;
		padding: 1rem 0;
		.col{
			.text{
				display: flex;
				justify-content: center!important;
				align-items: center!important;
			}
		}
	}
}

// 
// Products
// 
.products{
	.p-container{
		max-width: 60rem;
		margin-left: auto;
		margin-right: auto;
		display: flex;
		.card-item{
			width: 100%;
			padding: 1rem;			
		}
	}
	@include media-breakpoint-up(md){

		.p-container{
			justify-content: space-between!important;
		}
		.card-item{
			max-width: 50%;
			margin: auto;
			.card-container{
				margin-bottom: 0rem;
			}
			.card-content{
				padding: 1rem 2rem;
			}
		}
	}
	@include media-breakpoint-down(md){

		.p-container{
			flex-direction: column!important;
			.card-item{
				padding: .5rem;
			}
		}
	}
}

//
// Home Cards
//
.card-container{
	overflow: hidden;
	border-radius: $border-radius-md;
	box-shadow: $box-shadow-sm;
	position: relative;
	.card{
		.card-image{
			width: 100%;
			height: 60vh;
			background-color: #f2f2f2;
			border-radius: $border-radius-md $border-radius-md 0px 0;
			background-position: center;
			background-size: cover;
		}
	}
	@include media-breakpoint-up(md){
		.card{
			.card-image{
				height: 20rem;
			}
		}
	}
	@include media-breakpoint-down(md){
		&:first-child{
			margin-bottom: 1rem;
		}
	}
}

//
// Slide Nav
//

#fp-nav {
	position: fixed;
	z-index: 100;
	top: 50%;
	right: 1rem;
	animation-name: slideInRight;
	animation-duration: .5s;
	animation-fill-mode: both;
	ul{
		display: flex;
		flex-direction: column!important;
		align-items: center!important;
		li{
			margin: .25rem 0;
			a{
				width: .5rem;
				height: .5rem;
				background: black;
				opacity: .5;
				border-radius: .5rem;
				line-height: 0;
				font-size: 0px;
				display: flex;
				transition: all .35s $cubic-bezier .15s;

				&:hover{
					background-color: $paihuen;
					opacity: 1;
				}
				span{
					&.fp-sr-only{
						display: none;
					}
				}
				&.active{
					height: 1.5rem;
					background-color: $paihuen;
					opacity: 1;
					transition: all .35s $cubic-bezier .15s;
				}
			}
		}
	}
}

//
//
//
.svg-color-paihuen{
	max-width: 4rem;
	margin: 0 auto;
	opacity: .8;
	fill: gold;
}
.svg.svg-color-paihuen{
	svg{
		fill: $dark;
	}
}

.p-team-member{
	display: flex;
	align-items: center!important;
	.avatar{
		margin-right: 1rem;
		img{
			width: 4rem;
			border-radius: 100%;
			overflow: hidden;
			position: relative;
			display: block;
		}
	}
}
//
// Includes
//
section{
	&.welcome{
		padding-bottom: 0;
	}
	&.image-hero{
		@include media-breakpoint-down(md){
			padding: 0 1rem;
		}
		img{
			box-shadow: 0 2rem 3rem rgba(34,35,40,.075);
			filter: drop-shadow(0px 1rem 2rem rgba(34,35,40,.2));
			max-width: 90vw;
			margin: 0 auto !important;
			display: block;
			border-radius: 1rem;
			overflow: hidden;
			@include media-breakpoint-down(md){
				max-width: 100%;
			}
		}
	}
}

//
// Includes
//

footer{
	padding: 3rem 0;
	line-height: 2;
	a{
		color: gray;
		&:hover{
			color: $paihuen;
		}
	}
}

.footer-bar {
	position: fixed;
	bottom: 0;
	z-index: 9;
	max-width:  30rem;
	left: 1rem;
	margin: 0 auto;
	background-color: rgba(#f2f2f2,.97);
	padding: .5rem 0;
	border-radius: 1rem;
	display: flex;
	font-size: 1rem;
	line-height: 1;
	transform: translateY(100%);
	transition: all .35s $inOutQuad;
	&.isActive{
		transform: translateY(-1rem);
		transition: all .35s $inOutQuad;
	}
	.icon {
		width: 3rem;
		height: 3rem;
		overflow: hidden;
		background: white;
		border-radius: 1rem;
		svg{
			width: 3rem;
		}
	}
	.btn{
		font-size: .8rem;
		min-width: auto;
		padding: 0.3rem 0.6rem;
	}
}
//
// Shape
//
.background-shapes{
	.background-shapes-container{
		position: absolute;
		max-width: 100%;
		width: 1600px;
		height: 100%;
		overflow: hidden;
		.background-shapes-form{
			background-color:#F2FBF7;
			border-radius: 100%;
			width: 100%;
			// padding-top: 100%;
			position: absolute;
			bottom: 0%;
			left:  0%;
		}
	}
}
//
// Extras
//
.p-side-scroll-container{
	top: 50%;
	margin-top: 50px;
	z-index: 9;
	position: absolute;
	left: -2rem;
	.p-side-scroll{
		width: 150px;
		height: 50px;
		transform: rotate(90deg);
		line-height: 1.2;
		color: black;
		opacity: .5;
		font-weight: lighter;
		font-size: .8rem;
		letter-spacing: 1px;
		svg{
			width: 1.2rem;
			height: 1.2rem;
			bottom: -2px;
			position: relative;
		}
		span, svg{
			align-items: center!important;
			vertical-align: middle;
			display: inline-block;
		}
	}
	@include media-breakpoint-down(md){
		display: none;
	}
}
</style>


